import type {AppContext} from '@/entities/session/contexts';
import type {StatusTone} from '@/shared/ui/status';

/**
 * How a context looks and what it is called.
 *
 * The tone is not decoration: `home` and `company` are places where the user holds
 * the keys, so they carry the live/granted teal; `employee` is a place where someone
 * ELSE holds them and the user is merely on the list — neutral. Getting that backwards
 * would tell a hire, at a glance, that they administer their employer.
 *
 * Only keys leave this module — the strings live in the locale files.
 */
export type ContextBadge = {
  tone: StatusTone;
  /** i18n key naming the KIND of context ("Дом", "Организация", "Я — сотрудник"). */
  kindKey: string;
};

export function contextToneAndLabel(context: AppContext): ContextBadge {
  switch (context.kind) {
    case 'home':
      return {tone: 'online', kindKey: 'context.home'};
    case 'company':
      return {tone: 'granted', kindKey: 'context.company'};
    case 'employee':
      return {tone: 'neutral', kindKey: 'context.employee'};
  }
}
